<template>
  <v-layout fill-height row p0>
    <v-flex row xs10 offset-xs1 sm6 offset-sm3 md4 offset-md4 xl2 offset-xl5>
      <v-form class="v-center"
        v-model="startFormValid" ref="startForm"
      >
        <v-card flat class="transparent">
          <v-card-text>
            <img class="logo" src="../../assets/images/logo-asdetect-white.png" />
            <v-select :label="$t('MSG.PLEASE_CHOOSE_YOUR_LANGUAGE')" required color="teal lighten-1"
              class="start-hero-select select-long-label"
              :items="availableLangs"
              v-model="selectedLang"
              item-value="code"
              :rules="languageRules"
            ></v-select>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="secondary" dark class="ml-auto" @click.stop="goIntro">{{ $t("LBL.GO")}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
    <bottom-toolbar></bottom-toolbar>
  </v-layout>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import { UPDATE_USER_LANGUAGE } from '@/store/mutation-types'
import BottomToolbar from '@/components/elements/BottomToolbar'

export default {
  name: 'StarPage',
  components: {
    'bottom-toolbar': BottomToolbar
  },
  computed: {
    ...mapGetters([
      'userLanguage'
    ]),
    ...mapState([
      'availableLangs'
    ])
  },
  created () {
    this.$store.commit('UPDATE_APP_STEP', 2)
    this.selectedLang = this.userLanguage
  },
  data () {
    return {
      startFormValid: null,
      selectedLang: null,
      languageRules: [
        v => !!v || this.$i18n.t('RULE.FIELD_REQUIRED', {FIELD: this.$i18n.t('LBL.LANGUAGE')})
      ]
    }
  },
  methods: {
    goIntro () {
      if (this.$refs.startForm.validate()) {
        this.doUpdateLanguage(this.selectedLang)
        this.$router.push('/intro')
      }
    },
    ...mapMutations({
      doUpdateLanguage: UPDATE_USER_LANGUAGE
    })
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: block;
}

.footer {
  height: 4em;
}

.v-center {
  top: 50%;
  transform: translateY(-50%);
}

form {
  position: relative;
}

.logo {
  // width: 200px;
  width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/StartPage.vue